module.exports = __webpack_public_path__ + "static/media/KIT5.1a057e83.jpg";